import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React__default, { useReducer, useEffect, createContext } from 'react';
import { INITIAL_STATE, SERVER, SET_SERVER_PAGINATION, SET_CLIENT_PAGINATION, SET_COLUMNS, SET_GENERAL_STATE } from './utils/constants.js';
import tableReducer from './utils/reducer.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TableContext = /*#__PURE__*/createContext();
var TableProvider = function TableProvider(props) {
  var children = props.children,
    _props$pagination = props.pagination,
    pagination = _props$pagination === void 0 ? {} : _props$pagination;
  var _useReducer = useReducer(tableReducer, INITIAL_STATE),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  useEffect(function () {
    var isServer = (pagination === null || pagination === void 0 ? void 0 : pagination.type) === SERVER;
    if (isServer) {
      dispatch({
        payload: props,
        type: SET_SERVER_PAGINATION
      });
    }
    if (!isServer && Object.keys(pagination).length > 0) {
      var _props$data, _props$data$rowData;
      dispatch({
        payload: _objectSpread(_objectSpread({}, props), {}, {
          pagination: _objectSpread(_objectSpread({}, props.pagination), {}, {
            totalItems: props === null || props === void 0 ? void 0 : (_props$data = props.data) === null || _props$data === void 0 ? void 0 : (_props$data$rowData = _props$data.rowData) === null || _props$data$rowData === void 0 ? void 0 : _props$data$rowData.length
          })
        }),
        type: SET_CLIENT_PAGINATION
      });
    }
    dispatch({
      payload: props,
      type: SET_COLUMNS
    });
    dispatch({
      payload: props,
      type: SET_GENERAL_STATE
    });
  }, [props, pagination === null || pagination === void 0 ? void 0 : pagination.type]);
  return /*#__PURE__*/React__default.createElement(TableContext.Provider, {
    value: {
      dispatch: dispatch,
      state: state
    }
  }, children);
};

export { TableContext, TableProvider as default };
